import { Component, OnInit, Input } from "@angular/core"
import { Subject } from "rxjs"
import { getBase64 } from "app/shared/utils"

@Component({
    selector: "app-image-upload",
    templateUrl: "./image-upload.component.html",
    styleUrls: ["./image-upload.component.scss"],
    standalone: false
})
export class ImageUploadComponent implements OnInit {
  @Input() imageUrl: string
  @Input() uploadImageObservable: Subject<any>

  constructor() {}

  ngOnInit() {}

  extractImageName(value: string): string {
    const splitString = value.split("/")
    return splitString[splitString.length - 1]
  }

  onUploadImage(e): void {
    if (e.target.files.length > 0) {
      getBase64(e.target.files[0], (base64) => {
        this.uploadImageObservable.next(base64)
      })
    }
  }

  imageExists(): boolean {
    return this.imageUrl && this.imageUrl.length > 0
  }

  deleteImage() {
    this.imageUrl = ""
  }

  openImageNewTab(url: string) {
    window.open(url)
  }
}
